import EDC from '../../../shared/globals';
import BaseMinigamesPreloader from '../../../shared/base-minigames-scenes/base-preloader';
import { Thumbs } from '../../../shared/thumbs-animation';
import IngameMenuScene from '../../../shared/ingame-menu';
import MainScene from './main';
import store from '@/store/index';
import router from '@/router';
/**
 *
 */
EDC.Games.BinaryTextToImage.Scenes.Preloader = function () {
  BaseMinigamesPreloader.apply(this);
  this.isAllLoaded = false;
};
/**
 *
 */
// eslint-disable-next-line max-len
EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype = Object.create(BaseMinigamesPreloader.prototype);
// eslint-disable-next-line max-len
EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype.constructor = EDC.Games.BinaryTextToImage.Scenes.Preloader;

EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype.init = function () {
  this.scene.add('main', MainScene);
  this.scene.add('thumb', Thumbs);
  this.scene.add('ingame-menu', IngameMenuScene);
};

EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype.preload = function () {
  this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/loading-screen/');

  this.load.setPrefix('loading_screen_');
  this.load.image('background', 'background.png');
  this.load.image('dot', 'dot.png');
  this.load.image('loading', 'loading.png');
  this.load.image('progress_blur', 'progress_blur.png');

  for (let i = 1; i < 22; i++) {
    this.load.image(`progress_${i}`, `progress_${i}.png`);
  }
  this.load.setPrefix();
};

EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype.create = function () {
  // loading screen
  const bg = this.add.sprite(0, 0, 'loading_screen_background').setOrigin(0);
  const loading_text = this.add.sprite(885, 295, 'loading_screen_loading');
  const dot_1 = this.add.sprite(1330, 330, 'loading_screen_dot').setAlpha(0);
  const dot_2 = this.add.sprite(1390, 330, 'loading_screen_dot').setAlpha(0);
  const dot_3 = this.add.sprite(1450, 330, 'loading_screen_dot').setAlpha(0);
  const dotsTween = function (scene, dot_1, dot_2, dot_3) {
    const tween_1 = scene.tweens.add({
      targets: dot_1,
      alpha: 1,
      duration: 500,
      ease: 'Linear',
      yoyo: true,
      hold: 1500,
    });
    const tween_2 = scene.tweens.add({
      targets: dot_2,
      alpha: 1,
      duration: 500,
      delay: 500,
      ease: 'Linear',
      yoyo: true,
      hold: 1000,
    });
    const tween_3 = scene.tweens.add({
      targets: dot_3,
      alpha: 1,
      duration: 500,
      delay: 1000,
      ease: 'Linear',
      yoyo: true,
      hold: 500,
      onComplete: () => {
        dotsTween(scene, dot_1, dot_2, dot_3);
      },
    });
  };
  dotsTween(this, dot_1, dot_2, dot_3);
  const progress_blur = this.add.sprite(915, 630, 'loading_screen_progress_blur');
  const progress = this.add.sprite(915, 630, 'loading_screen_progress_1');
  this.load.on('progress', (value) => {
    let key = value * 100;
    key = Math.floor(key / 5) + 1;
    progress.setTexture(`loading_screen_progress_${key}`);
  });

  this.load.on('complete', this.loadingComplete, this);

  const gameId = router.currentRoute.params.id;
  const cfg = store.getters['games/getGameById'](gameId).sets[0].config;

  const { font } = cfg;

  const customFont = new FontFace(
    font,
    `url(https://s3.amazonaws.com/images.growmindgrow/phaser-assets/fonts/${font}.otf)`,
    {
      style: 'normal',
      weight: 'normal',
    },
  );
  document.fonts.add(customFont);
  customFont.load().then(this.loadingComplete());

  this.addPreloaders(cfg, { question: false });

  this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/games/');

  this.load.spritesheet('star-explode', '055/star-explode.png', {
    frameWidth: 120,
    frameHeight: 120,
  });

  for (let i = 1; i < 5; i++) {
    this.load.image(`candy-${i}`, `Binary-Text-To-Image/candy-${i}.png`);
  }

  this.load.image('gumball', 'Binary-Text-To-Image/gumball.png');

  const { titleImg } = cfg;
  this.load.image('title', titleImg);

  const { instructionsImg } = cfg;
  this.load.image('instructions', instructionsImg);

  const { assets } = cfg;
  for (let i = 0; i < assets.labels.length; i++) {
    const asset = assets.labels[i];
    this.load.image(`label-${asset.id}`, asset.img);
  }

  this.load.setPath();
  this.load.start();
};
/**
 *
 */

EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype.loadingComplete = function () {
  this.onLoadImagesComplete();
  this.isAllLoaded = true;
};

EDC.Games.BinaryTextToImage.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  if (this.isAllLoaded) {
    this.load.off(this.onLoadImagesComplete, this);
    this.scene.start('main');
  }
};

export default EDC.Games.BinaryTextToImage.Scenes.Preloader;
